import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import { withStyles } from "@mui/styles";
import { List, ListItem } from "@mui/material";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
});

function TeamDetails(props) {
  let teamDetails = props.teamDetails;
  const teamList = teamDetails.map((teamDetails, i) => (
    <ListItem key={i}>
      <Paper>
        <Table classes={{ root: "reactivetable" }}>
          <TableBody>
            <TableRow key={i.id}>
              <TableCell component="th" scope="row">
                id
              </TableCell>
              <TableCell data-th="Owner id">
                {teamDetails.user_id ? teamDetails.user_id : "error"}
              </TableCell>
            </TableRow>
            <TableRow key={i.name}>
              <TableCell component="th" scope="row">
                Name
              </TableCell>
              <TableCell data-th="Name">
                {teamDetails.first
                  ? teamDetails.first + " " + teamDetails.last
                  : "error"}
              </TableCell>
            </TableRow>
            <TableRow key={i.company}>
              <TableCell component="th" scope="row">
                Company
              </TableCell>
              <TableCell data-th="company">
                {teamDetails.company ? teamDetails.company : "Not Defined"}
              </TableCell>
            </TableRow>
            <TableRow key={i.email}>
              <TableCell component="th" scope="row">
                Email
              </TableCell>
              <TableCell data-th="email">
                {teamDetails.email ? teamDetails.email : "Not Defined"}
              </TableCell>
            </TableRow>
            <TableRow key={i.phone}>
              <TableCell component="th" scope="row">
                Phone
              </TableCell>
              <TableCell data-th="email">
                {teamDetails.phone ? teamDetails.phone : "Not Defined"}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </ListItem>
  ));

  let pendingTeamDetails = props.pendingTeamDetails;
  const pendingTeamList = pendingTeamDetails.map((pendingTeamDetails, x) => (
    <ListItem key={x}>
      <Paper>
        <Table classes={{ root: "reactivetable" }}>
          <TableBody>
            <TableRow key={x.email}>
              <TableCell component="th" scope="row">
                Email
              </TableCell>
              <TableCell data-th="email">
                {pendingTeamDetails.email
                  ? pendingTeamDetails.email
                  : "Not Defined"}
              </TableCell>
            </TableRow>
            <TableRow key={x.sent}>
              <TableCell component="th" scope="row">
                Sent
              </TableCell>
              <TableCell data-th="sent">
                {pendingTeamDetails.sent
                  ? pendingTeamDetails.sent
                  : "Not Defined"}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </ListItem>
  ));

  let removedTeamDetails = props.removedTeamDetails;
  const removedTeamList = removedTeamDetails.map((removedTeamDetails, y) => (
    <ListItem key={y}>
      <Paper>
        <Table classes={{ root: "reactivetable" }}>
          <TableBody>
            <TableRow key={y.email}>
              <TableCell component="th" scope="row">
                Email
              </TableCell>
              <TableCell data-th="email">
                {removedTeamDetails ? removedTeamDetails : "Not Defined"}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </ListItem>
  ));

  return (
    <Container maxWidth="lg">
      <Grid container spacing={3}>
        {teamDetails ? (
          <Grid item xs={12} md={8} lg={4}>
            <h3> Active TeamMembers</h3>

            {teamDetails ? <List>{teamList}</List> : null}
          </Grid>
        ) : null}
        {pendingTeamDetails ? (
          <Grid item xs={12} md={8} lg={4}>
            <h3> Pending TeamMembers</h3>

            {pendingTeamDetails ? <List>{pendingTeamList}</List> : null}
          </Grid>
        ) : null}

        {removedTeamDetails ? (
          <Grid item xs={12} md={8} lg={4}>
            <h3> Removed TeamMembers</h3>

            {removedTeamDetails ? <List>{removedTeamList}</List> : null}
          </Grid>
        ) : null}
      </Grid>
    </Container>
  );
}

// export default withStyles(styles, { withTheme: true })(TeamDetails);
export default TeamDetails